import { DeliveryOrderService } from './../../../../transport-operation/services/delivery-order.service';
import { EventEmitter, Injector, Input, Output } from '@angular/core';
import { ViewChild } from '@angular/core';
import { Component, OnInit } from '@angular/core';
import { FileUpload } from 'primeng/fileupload';
import { SessionBaseComponent } from 'src/app/shared/components/session.base.component';
import { UserPreferenceConstants } from 'src/app/core/constants/user-preference-constants.constant';
import { CommonDataService } from 'src/app/core/services/common-data.service';
import { WarehousingSearchService } from '../../../services/warehousing-search.service';
import { PermissionConstants } from 'src/app/core/constants/permission-constants.constant';

@Component({
  selector: 'laas-warehousing-rmb-price-import',
  templateUrl: './warehousing-rmb-price-import.component.html',
  styleUrls: ['./warehousing-rmb-price-import.component.scss']
})
export class WarehousingRmbPriceImportComponent extends SessionBaseComponent implements OnInit {

  @ViewChild('fileUpload') fileUpload!: FileUpload;
  @Output() uploadClick: EventEmitter<any>;

  readonly permissionCode: PermissionConstants = PermissionConstants.UpdateRmbPrice;
  readonly preferenceKey: string;
  warehousingRMBPriceRows: any[];
  isLoading: boolean;
  submitted: boolean;
  columns: any[];

  constructor(
    injector: Injector,
    private commonDataService: CommonDataService,
    private warehousingSearchService: WarehousingSearchService,
    private DOService: DeliveryOrderService
  ) {
    super(injector);
    this.preferenceKey = UserPreferenceConstants.WarehousingRMBPriceImport;
    this.warehousingRMBPriceRows = [];
    this.isLoading = false;
    this.submitted = false;
    this.uploadClick = new EventEmitter<any>();

    this.columns = [
      { field: 'whNo', header: '入倉單號', sort: true },
      { field: 'sku', header: '料號', sort: true },
      { field: 'coo', header: '產地', sort: true },
      { field: 'unitPrice', header: '單價', sort: true }
    ];
  }

  async ngOnInit(): Promise<void> {
    await super.ngOnInit();

    //rbac to maintain this page
    var canInPage = this.permissionCodes.includes(this.permissionCode);
    if (!canInPage) {
      //go unAuthorize
      this.routeStateService.navigateTo('/Error/unAuthorize');
    }
  }

  fileUploader(event: any): void{
    this.isLoading = true;
    this.warehousingSearchService.importWarehousingRMBPriceByExcel(event.files[0]).subscribe({
      next: result => {
        this.warehousingRMBPriceRows = result;
      },
      complete: () => {
        this.clearUploadUI();
        this.isLoading = false;
      }
    });
  }

  clearUploadUI(): void{
    this.fileUpload.clear();
  }

  importClickBtn(event: any): void{
    this.submitted = true;
    // check validation
    if (this.warehousingRMBPriceRows.some(x => x.whNo === null)){
      this.toastService.warn('請檢查入倉單號是否填寫');
      return;
    }
    if (this.warehousingRMBPriceRows.some(x => x.sku === null)){
      this.toastService.warn('請檢查料號是否填寫');
      return;
    }
    if (this.warehousingRMBPriceRows.some(x => x.coo === null)){
      this.toastService.warn('請檢查產地是否填寫');
      return;
    }
    if (this.warehousingRMBPriceRows.some(x => x.unitPrice === null)){
      this.toastService.warn('請檢查單價是否填寫');
      return;
    }
    this.warehousingRMBPriceRows.forEach((x: any) => {
      x.createUser = this.userProfile.userName;
      x.updateUser = this.userProfile.userName;
    });

    this.warehousingSearchService.addWarehousingRMBPrice(this.warehousingRMBPriceRows).subscribe({
      next: result => {
        this.translateService.get('Common.Message.SuccessSave')
            .subscribe({
              next: msg => {
                this.toastService.success(msg);

                this.warehousingRMBPriceRows = [];
                this.routeStateService.navigateTo('/TransportOperation/WarehousingSearch', '');
              }
            });
      },
      error: err => {
        this.toastErrorMessage(err.error);
      }
    });
  }

  templateDownloadClickBtn(event: any): void{
    this.commonDataService.getSystemParam('WarehousingRmbPrice').subscribe({
      next: result => {
        var searchObj = {
          sn: result[0].sn,
          version: result[0].version
        };

        this.DOService.downloadFile(searchObj).subscribe(x => {
          var blob = new Blob([x], { type: 'application/octet-stream' }); // application後面接下載的副檔名

          let downloadURL = window.URL.createObjectURL(blob);
          let link = document.createElement('a');
          link.href = downloadURL;
          link.download = `UploadRmbPrice.xlsx`;
          link.click();
        });
      }
    });

  }
}
